export default {
	INIT: 0,
	LOADING: 1,
	READY: 2,
	LOADING_MORE: 3,
}
